import { ShaderStore } from "@babylonjs/core";
const name = "textureVertexDeclaration";
const shader = `in vec4 textureDepths;out vec2 vUvs;flat out float depth;`;
ShaderStore.IncludesShadersStore[name] = shader;
export const textureVertexDeclaration = { name, shader };
//# sourceMappingURL=textureVertexDeclaration.js.map